module.exports = __webpack_public_path__ + "img/Storage=Category-On.7c2f802f.svg";